import clsx from 'clsx'

import { CellSchema } from '../module'
import s from '../styles.module.scss'

export const SeatOccupied = ({ seat }: CellSchema) => {
  return (
    <div className={clsx(s.container, s.occupiedContainer)}>
      <div className={clsx('medium-18', s.occupied)}>{seat}</div>
    </div>
  )
}
